import Odoo from './Odoo';

class PacksAPIClass{
    getPacks(uid, pakowalnia_id){
      var params = [
        JSON.stringify({
          'uid': uid,
          'pakowalnia': pakowalnia_id
        })
      ]

      return new Promise((resolve, reject) => {
        Odoo.call('stock.order.packages', 'get_packages_v2', params).then(packs => {
          resolve(packs)
        }).catch(err=>{
          reject(err)
        })
      })
    }

    searchCodes(pack, pattern){
      var params = [
        JSON.stringify({
          'id_paczki': pack,
          'szukana_fraza': pattern
        })
      ]
      return new Promise((resolve, reject) => {
        Odoo.call('stock.order.packages', 'default_code_autocomplete_v2', params).then(codes => {
          resolve(codes)
        }).catch(err=>{
          reject(err)
        })
      })
    }

    getVariants(kod, uid, pakowalnia_id, pack){
      var params = [
        JSON.stringify({
          'ean': kod,
          'id_paczki': pack,
          'pakowalnia_id': pakowalnia_id,
          'uid': uid
        })
      ]

      return new Promise((resolve, reject) => {
        Odoo.call('stock.order.packages', 'get_variants_by_ean_v2', params).then(variants => {
          resolve(variants)
        }).catch(err=>{
          reject(err)
        })
      })
    }

    getOrder(kod, uid, pakowalnia_id, pack, multi_order_id = false){
      var params = [
        JSON.stringify({
          'ean': kod,
          'id_paczki': pack,
          'pakowalnia_id': pakowalnia_id,
          'uid': uid,
          'multi_order_id': multi_order_id
        })
      ]

      return new Promise((resolve, reject) => {
        Odoo.call('stock.order.packages', 'get_order_by_ean_v2', params).then(order_json => {
          resolve(order_json)
        }).catch(err=>{
          reject(err)
        })
      })
    }

    getCart(kod, uid, pakowalnia_id){
      var params = [
        JSON.stringify({
          'barcode': kod,
          'pakowalnia_id': pakowalnia_id,
          'uid': uid
        })
      ]

      return new Promise((resolve, reject) => {
        Odoo.call('stock.order.packages', 'get_pack_by_cart_barcode_v2', params).then(pack => {
          resolve(pack)
        }).catch(err=>{
          reject(err)
        })
      })
    }

    processPakowanie(values){
      var params = [
        JSON.stringify(values)
      ]

      return new Promise((resolve, reject) => {
        Odoo.call('stock.order.packages', 'fulfill_order_v2', params).then(pack => {
          resolve(pack)
        }).catch(err=>{
          reject(err)
        })
      })
    }

    recieveMultipack(pack, uid){
      var params = [
        JSON.stringify({
          'pack_id': pack,
          'uid': uid
        })
      ]

      return new Promise((resolve, reject) => {
        Odoo.call('stock.order.packages', 'get_multipack_data_v2', params).then(boxes => {
          resolve(boxes)
        }).catch(err=>{
          reject(err)
        })
      })
    }

    releaseOrder(order_id){
      var params = [
        JSON.stringify({
          'order_id': order_id
        })
      ]

      return new Promise(() => {
        Odoo.call('stock.order.packages', 'release_pakowalnia_order_v2', params)
      })
    }

    addPackage(order, carrier, uid, pakowalnia_id, inpost_size){
      var params = [
        JSON.stringify({
          'order_id': order,
          'carrier_id': carrier,
          'uid': uid,
          'pakowalnia_id': pakowalnia_id,
          'inpost_size': inpost_size
        })
      ]

      return new Promise((resolve, reject) => {
        Odoo.call('sale.order', 'generate_new_package_v2', params).then(res => {
          resolve(res)
        }).catch(err=>{
          reject(err)
        })
      })
    }

    addDelivery(order, carrier, uid, pakowalnia_id){
      var params = [
        JSON.stringify({
          'order_id': order,
          'carrier_id': carrier,
          'uid': uid,
          'pakowalnia_id': pakowalnia_id
        })
      ]

      return new Promise((resolve, reject) => {
        Odoo.call('sale.order', 'generate_new_delivery_v2', params).then(res => {
          resolve(res)
        }).catch(err=>{
          reject(err)
        })
      })
    }

    printLabelAgain(order, pakowalnia_id){
      var params = [
        JSON.stringify({
          'order_id': order,
          'pakowalnia_id': pakowalnia_id
        })
      ]

      return new Promise((resolve, reject) => {
        Odoo.call('sale.order', 'print_label_again_v2', params).then(res => {
          resolve(res)
        }).catch(err=>{
          reject(err)
        })
      })
    }

    printInvoice(order, uid, pakowalnia_id){
      var params = [
        JSON.stringify({
          'order_id': order,
          'uid': uid,
          'pakowalnia_id': pakowalnia_id
        })
      ]

      return new Promise((resolve, reject) => {
        Odoo.call('stock.order.packages', 'pakowalnia_print_invoice_v2', params).then(res => {
          resolve(res)
        }).catch(err=>{
          reject(err)
        })
      })
    }
}

const PacksAPI = new PacksAPIClass()

export default PacksAPI;



// WEBPACK FOOTER //
// ./src/utils/PackAPI.js